import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


import { styled } from '../styles/index.js';
import { getInputStyles, getInputContainerStyles } from '../input/styled-components.js'; // $FlowFixMe https://github.com/facebook/flow/issues/7745

export var StyledTextareaContainer = styled('div', function (props) {
  return _objectSpread2({}, getInputContainerStyles(props));
}); // $FlowFixMe https://github.com/facebook/flow/issues/7745

StyledTextareaContainer.displayName = "StyledTextareaContainer";
export var StyledTextarea = styled('textarea', function (props) {
  return _objectSpread2({}, getInputStyles(props), {
    resize: 'none'
  });
});
StyledTextarea.displayName = "StyledTextarea";